import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import homeImg1 from '../../assets/images/1.jpeg';
import homeImg2 from '../../assets/images/2.jpeg';
import homeImg4 from '../../assets/images/4.jpeg';

// Updated slide data
const slides = [
  {
    id: 1,
    badge: 'Physiotherapy Equipment',
    title: 'Advanced Therapy Equipment',
    subtitle: '', // (optional – can be left empty)
    description:
      'Innovative physiotherapy and occupational therapy solutions for clinics, schools, sensory rooms, and homes.',
    image: homeImg4,
    ctaText: 'Shop Collection',
    ctaLink: '/Categories',
  },
  {
    id: 2,
    badge: 'Rehabilitation & Sensory',
    title: 'Support Every Recovery',
    subtitle: '',
    description:
      'High-quality rehabilitation, sensory integration, and therapy furniture designed for comfort and development.',
    image: homeImg2,
    ctaText: 'Explore Products',
    ctaLink: '/ProductList',
  },
  {
    id: 3,
    badge: 'All Categories',
    title: 'Explore Our Categories',
    subtitle: '',
    description:
      'Browse physiotherapy equipment, occupational therapy products, sensory integration solutions, therapy furniture, and more.',
    image: homeImg1,
    ctaText: 'View All',
    ctaLink: '/Categories',
  },
];

export default function Home() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  // Auto-slide every 5 seconds with a fade effect
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // start fade out
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % slides.length);
        setFade(true); // fade in after changing content
      }, 300); // match the CSS transition duration
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const currentSlide = slides[currentIndex];

  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        {/* Left column – content */}
        <div
          className={`lg:col-span-6 z-10 transition-opacity duration-300 ease-in-out ${
            fade ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-bold tracking-widest text-on-secondary-fixed-variant bg-secondary-fixed uppercase rounded-full">
            {currentSlide.badge}
          </span>
          <h1 className="font-headline text-5xl md:text-5xl font-extra font-bold leading-[1.1] mb-8 tracking-tight">
            <span className="text-[#1b2f3e]">{currentSlide.title}</span>{' '}
            {currentSlide.subtitle && (
              <span className="text-gray-800">{currentSlide.subtitle}</span>
            )}
          </h1>
          <p className="text-lg text-gray-700 mb-10 max-w-lg leading-relaxed">
            {currentSlide.description}
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to={currentSlide.ctaLink}
              className="px-8 py-4 bg-primary text-on-primary rounded-xl font-bold shadow-lg hover:shadow-primary/20 transition-all scale-100 active:scale-95 inline-block"
            >
              {currentSlide.ctaText}
            </Link>
          </div>
        </div>

        {/* Right column – image */}
        <div
          className={`lg:col-span-6 relative transition-opacity duration-300 ease-in-out ${
            fade ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="aspect-square rounded-[3rem] overflow-hidden shadow-2xl relative">
            <img
              alt={currentSlide.title}
              className="w-full h-full object-cover"
              src={currentSlide.image}
              width="auto"
              height="auto"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/30 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}